import { Component, Input, OnInit } from '@angular/core'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { Relationships } from '../../models/relationships'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { PhoneNumberInputMask } from './phone-number.input-mask'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { PowerOfAttorneyModel } from '../../models/power-of-attorney'

@Component(
    {
        selector: 'PowerOfAttorneyForm',
        templateUrl: './power-of-attorney-form.component.html'
    }
)

export class PowerOfAttorneyFormComponent implements OnInit {
    @Input() powerOfAttorneyModel: PowerOfAttorneyModel

    relationships: ValidatedSelectOptionModel[] = []

    notBlankValidator: NotBlankGenericFieldValidator = new NotBlankGenericFieldValidator()
    numericValidator = new NumericTextFieldValidator()
    phoneNumberValidator = new LengthTextFieldValidator(10)
    phoneNumberInputMask = new PhoneNumberInputMask()

    ngOnInit(): void {
        for (let relationship in Relationships) {
            if (Relationships.hasOwnProperty(relationship)) {
                this.relationships.push({
                    value: relationship,
                    text: Relationships[relationship]
                })
            }
        }
    }
}
